"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Background = void 0;
var GameVars_1 = require("../GameVars");
var GameConstants_1 = require("../GameConstants");
var Background = /** @class */ (function (_super) {
    __extends(Background, _super);
    function Background(scene) {
        var _this = _super.call(this, scene) || this;
        var d = 0;
        while (d < GameVars_1.GameVars.gameWidth) {
            var strip = new Phaser.GameObjects.Image(_this.scene, d, 0, "texture_atlas_0", GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "bg_strip" : "bg_strip_2");
            strip.setOrigin(0, 0);
            strip.setScale(GameVars_1.GameVars.gameHeight / strip.height);
            _this.add(strip);
            d += strip.width * GameVars_1.GameVars.gameHeight / strip.height;
        }
        var yAnchor;
        if (GameVars_1.GameVars.isDesktop) {
            yAnchor = .65;
        }
        else {
            if (GameVars_1.GameVars.aspectRatio <= 1.5) {
                yAnchor = .54;
            }
            else {
                yAnchor = .465;
            }
        }
        var awning = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_0", "header");
        awning.setOrigin(0, yAnchor);
        awning.scaleY = GameVars_1.GameVars.scaleY;
        _this.add(awning);
        awning = new Phaser.GameObjects.Image(_this.scene, awning.width, 0, "texture_atlas_0", "header");
        awning.setOrigin(0, yAnchor);
        awning.scaleY = GameVars_1.GameVars.scaleY;
        _this.add(awning);
        awning = new Phaser.GameObjects.Image(_this.scene, awning.width * 2, 0, "texture_atlas_0", "header");
        awning.setOrigin(0, yAnchor);
        awning.scaleY = GameVars_1.GameVars.scaleY;
        _this.add(awning);
        if (GameVars_1.GameVars.isDesktop) {
            awning = new Phaser.GameObjects.Image(_this.scene, awning.width * 3, 0, "texture_atlas_0", "header");
            awning.setOrigin(0, yAnchor);
            awning.scaleY = GameVars_1.GameVars.scaleY;
            _this.add(awning);
        }
        return _this;
    }
    return Background;
}(Phaser.GameObjects.Container));
exports.Background = Background;
